// extracted by mini-css-extract-plugin
export default {"component":"weeklyInfoRoot__component___U0rl3"};